// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Opsu","toggle":"styles_toggle__vzl_x","preview":"styles_preview__1Cxxw"};